































import { Component, Vue } from 'vue-property-decorator';

import { ECustomerInactivityStepSlug } from '@/models/customer-inactivity';

import customerInactivity from '@/constants/customerInactivity';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import CustomerInactivityInfoTabs from '@/componentsV2/organisms/CustomerInactivityInfoTabs/CustomerInactivityInfoTabs.vue';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    CustomerInactivityInfoTabs,
    FilledButton
  }
})
export default class InfoInactivity extends Vue {
  customerInactivity = customerInactivity;

  get business() {
    const { business = null } = this.$store.getters['business/getBusinessInfo'];

    return business;
  }

  get customerInactivityDaysConfig() {
    return this.business.inactiveCustomerDays;
  }

  handleGotIt() {
    this.$emit('customer-inactivity-event', { type: 'closeModal' });
  }

  handleGoToEditStep() {
    segmentIo.modal('Inactive Consumers Edit', {
      From: 'Inactive Consumers Learn More Modal'
    });
    this.$emit('customer-inactivity-event', {
      type: 'goToStep',
      params: { redirectToStep: ECustomerInactivityStepSlug.EDIT }
    });
  }
}
